import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { NavigateBefore, NavigateNext } from "@mui/icons-material";
import { FormControl, IconButton, InputBase, MenuItem, Select, styled, useMediaQuery, useTheme } from "@mui/material";
import ThemeProvider from "../../theme";
import { FONTSTYPO, SPACING } from "../../theme/palette";
const PaginationDetails = styled("div")(() => ({
    "alignItems": "center",
    "display": "flex",
    "gap": SPACING.space2xsxs
}));
const PaginationPerPage = styled("div")(() => ({
    "alignItems": "center",
    "display": "flex",
    "gap": SPACING.space2xsxs,
    "justifyContent": "center"
}));
const PaginationPageNumber = styled("div")(() => ({
    "alignItems": "center",
    "display": "flex",
    "gap": SPACING.space2xsxs,
    "height": SPACING.spacem,
    "justifyContent": "center"
}));
const PagingButton = styled(IconButton)(() => ({
    "padding": SPACING.space2xsxs
}));
const PagingInput = styled(InputBase)(({ theme }) => ({
    "& .MuiInputBase-input": {
        "alignItems": "flex-start",
        "border": `1px solid ${theme.palette.grey[200]}`,
        "borderRadius": FONTSTYPO.stepMinues2,
        "boxShadow": `0px 1px 3px 0px ${theme.palette.grey[300]} inset`,
        "display": "flex",
        "gap": SPACING.space2xsxs,
        "padding": `${SPACING.space2xsxs} ${SPACING.space2xsxs} ${SPACING.space2xsxs} ${SPACING.spacexss}`,
        "width": "auto"
    }
}));
const perPageOptions = window.Array.from(new window.Array(101).keys()).filter(key => key !== 0 && key % 10 === 0);
const Pagination = (props) => {
    const { currentPage, mobileBreakpoint = 992, perPage, totalResults, updatePagination } = props;
    const currentPagination = {
        "currentPage": currentPage,
        "perPage": perPage
    };
    const totalPages = window.Math.ceil(totalResults / perPage);
    const handlePerPageChange = (selectChangeEvent) => {
        updatePagination({
            "currentPage": 1,
            "perPage": window.Number.parseInt(selectChangeEvent.target.value)
        });
    };
    const handlePrevious = () => {
        if (currentPage > 1) {
            updatePagination(Object.assign(Object.assign({}, currentPagination), { "currentPage": currentPage - 1 }));
        }
    };
    const handleNext = () => {
        if (currentPage < totalPages) {
            updatePagination(Object.assign(Object.assign({}, currentPagination), { "currentPage": currentPage + 1 }));
        }
    };
    const theme = useTheme();
    const mobile = !useMediaQuery(theme.breakpoints.up(mobileBreakpoint));
    return (_jsx(ThemeProvider, { children: _jsxs(PaginationDetails, { children: [_jsxs(PaginationPerPage, { children: [_jsx(FormControl, { children: _jsx(Select, Object.assign({ defaultValue: perPage.toString(), input: _jsx(PagingInput, { sx: {
                                        "& .MuiInputBase-input": {
                                            "max-width": `${perPage.toString().length.toString()}ch`
                                        }
                                    } }), onChange: handlePerPageChange }, { children: perPageOptions.map(perPageOption => (_jsx(MenuItem, Object.assign({ value: perPageOption }, { children: perPageOption }), perPageOption))) })) }), `Items of ${totalResults}`] }), _jsxs(PaginationPageNumber, { children: ["Page", _jsx(FormControl, Object.assign({ hiddenLabel: true }, { children: _jsx(PagingInput, { inputProps: { "aria-label": "Current Page" }, sx: {
                                    "& .MuiInputBase-input": {
                                        "max-width": `${currentPage.toString().length.toString()}ch`,
                                        "padding": SPACING.space2xsxs,
                                        "textAlign": "center"
                                    }
                                }, value: currentPage }) })), "of", _jsx("span", { children: totalPages })] }), mobile ? (_jsx(_Fragment, {})) : (_jsxs("div", { children: [_jsx(PagingButton, Object.assign({ "aria-label": "previous page", disabled: currentPage === 1, onClick: handlePrevious, size: "small" }, { children: _jsx(NavigateBefore, {}) })), _jsx(PagingButton, Object.assign({ "aria-label": "next page", disabled: currentPage === totalPages, onClick: handleNext, size: "small" }, { children: _jsx(NavigateNext, {}) }))] }))] }) }));
};
export { Pagination };
